import React, { useState } from "react";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import "../../assets/css/Care-Registration.css";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { DeleteServicesAction } from "../../redux/actions/auth";

const MyServices = ({ navigation, auth, deleteService }) => {
    const navigate = useNavigate();
    const [editService, setEditService] = useState("");
    const [editBtn, setEditBtn] = useState(false);

    const deleteServiceFn = (id) => {
        deleteService(id).then(() => {});
    };

    return (
        <>
            <Header />
            {/* <!-- Care Giver Registration Form --> */}
            <div className="care-registration">
                <div className="container">
                    <div className="top_bar">
                        <div className="heading_wrapper">
                            <h2>My Services</h2>
                            <p>
                                Manage all your services on the go with ease and
                                comfort. We have a streamlined process that can
                                help you add your new services or delete the
                                existing ones. Explore this page to know more.
                            </p>
                        </div>
                    </div>
                    <div id="wizard">
                        <section id="tabcontent" className="second_tab">
                            <div className="head_wrapper">
                                <h5>Services Setup</h5>
                                <p>
                                    Select Services you want to provide .You can
                                    select multiple service
                                </p>
                            </div>
                            <Link
                                to={"/add-services"}
                                className="btn btn-danger"
                            >
                                Add Services
                            </Link>
                            <div className="mt-3">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Service</th>
                                            <th scope="col">Edit</th>
                                            <th scope="col">Delete</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {auth.user.services.map((service) => (
                                            <tr key={service.service.id}>
                                                <td>{service.service.title}</td>
                                                {/* <td /> */}
                                                <td
                                                    onClick={() =>
                                                        navigate(
                                                            `/edit-service/${service.id}`
                                                        )
                                                    }
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    Edit
                                                </td>
                                                <td
                                                    onClick={() =>
                                                        deleteServiceFn(
                                                            service.id
                                                        )
                                                    }
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    Delete
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </section>

                        <div className="bottom_bar">
                            <div className="note">
                                <p>
                                    Note: service providers (e.g. sitters) must
                                    abide by applicable laws and regulations.{" "}
                                    <a href="#" style={{ color: "#000" }}>
                                        Terms of Service
                                    </a>
                                </p>
                            </div>
                            {/* <div className="button-group">
                    <button className="btn">Cancel</button>
                    <button className="btn ml-2"
                     onClick={()=>Navigate('/care-giver-registration3')}
                    >Save Changes</button>
                </div>  */}
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Care Giver Registration Form --> */}
            <Footer />
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
    deleteService: async (service_id) =>
        dispatch(await DeleteServicesAction(service_id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyServices);
